export function NotFoundScreen() {
  return (
    <main data-testid="screen-not-found">
      <h1>404</h1>
    </main>
  );
}
